export default __webpack_public_path__ + "static/media/encryption.0396c062.webp";